export default __webpack_public_path__ + "static/media/NETWORK_888.5c2faea6.png";